import styled from 'styled-components';
import { containerBoxShadow } from 'design-system/src/sharedStyles';
import { ItemAlignment } from './types';

const StyledContainer = styled.div`
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--grayscale-100);
  background: var(--white);

  ${containerBoxShadow}
`;

export const ActionCard = styled(StyledContainer)<{ $width?: string; alignItems?: ItemAlignment }>`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  gap: 8px;
  padding: 16px;
  flex-wrap: wrap;
  width: ${({ $width }) => $width || 'auto'};
`;
